// Hospitality H1 (Sep 2026) — Host Partner (hotel/motel) portal client.
//
// Deliberately SEPARATE from `lib/api.js` / `lib/auth.jsx`: a host
// account's token lives under its own storage key and is only ever sent
// to `/api/host/*`. It is never written to `ren_token`, so the restaurant
// dashboard's AuthProvider never sees a host identity, and the backend's
// `get_user` refuses a host token on every restaurant route regardless.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const HOST_TOKEN_KEY = "rudras_host_token";

export const HOST_ROLES = new Set(["host_viewer"]);
export const isHostRole = (role) => HOST_ROLES.has(role);

export function getHostToken() {
  try { return localStorage.getItem(HOST_TOKEN_KEY); } catch (_e) { return null; }
}

export function setHostToken(token) {
  try { localStorage.setItem(HOST_TOKEN_KEY, token); } catch (_e) { /* noop */ }
}

export function clearHostToken() {
  try { localStorage.removeItem(HOST_TOKEN_KEY); } catch (_e) { /* noop */ }
}

export const hostApi = axios.create({ baseURL: `${BACKEND_URL}/api/host` });

hostApi.interceptors.request.use((cfg) => {
  const token = getHostToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function hostErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  if (typeof detail === "string") return detail;
  return fallback;
}

export async function hostLogin(email, password) {
  const { data } = await axios.post(`${BACKEND_URL}/api/host/auth/login`, { email, password });
  setHostToken(data.token);
  return data;
}

export function formatUsd(amount) {
  const n = Number(amount || 0);
  return n.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function formatTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch (_e) { return iso; }
}
